__turbopack_context__.v({
  "store-stock-info__product-available": "_2KiY5G_store-stock-info__product-available",
  "store-stock-info__product-unavailable": "_2KiY5G_store-stock-info__product-unavailable",
});
